import React, { useCallback, useState, useMemo, useEffect } from "react";
import Table from "../../../../../common/element/Table";
import Button from "../../../../../common/element/Buttons";
import { useNavigate, useSearchParams } from "react-router-dom";
import { debounce } from "../../../../../common/snippet/Debouncing";
import ModernPagination from "../../../../../common/pagination/ModernPagination";
import { Pagination } from "../../../../../common/pagination";
import ToolManagmentCard from "../../../../../common/element/Card/ToolManagmnetCard";
import AddEditCompanyEmployee from "./editCompanyEmployee";
import DeleteModal from "../../../../../common/Common/DeleteModal";
import { useDispatch, useSelector } from "react-redux";
import { getCompanyEmployees } from "../../../../../redux/ProspectCompany/companyProspectSlice";
import {
    selectCompanyEmployeesList,
    selectCompanyEmployeesLoading,
    selectCompanyEmployeesTotal
} from "../../../../../redux/ProspectCompany/companyProspectSelectors";
import ThreeDotBouncingLoader from "../../../../../common/element/ButtonLoader/ThreeDotBouncingLoder";
import CommonIconButton from "../../../../../common/icons/CommonIconButton";

const { Tr, Th, Td, THead, TBody } = Table;

const CompaniesEmployeesList = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const companyId = searchParams.get("id");
    const dispatch = useDispatch();

    const employeesList = useSelector(selectCompanyEmployeesList);
    const isLoading = useSelector(selectCompanyEmployeesLoading);
    const totalCount = useSelector(selectCompanyEmployeesTotal);

    const [filterpage, setfilterpage] = useState(1);
    const [filterlimit, setfilterlimit] = useState(10);
    const [isOpen, setIsopen] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [getFilterData, SetFilterData] = useState({
        page: 1,
        limit: 10,
        sort: "created_date",
        order: "desc",
        search: "",
    });

    const totalPages = Math.ceil(totalCount / filterlimit);

    useEffect(() => {
        if (companyId) {
            dispatch(getCompanyEmployees({
                companyId,
                page: filterpage,
                limit: filterlimit,
                search: getFilterData.search
            }));
        }
    }, [dispatch, companyId, filterpage, filterlimit, getFilterData.search]);

    const handleSearch = (e) => {
        const value = e.target.value.trim();
        SetFilterData((prev) => ({ ...prev, search: value }));
        setfilterpage(1); // Reset to first page on search
    };

    const handleDelete = () => {
        setIsopen(false);
    };

    const inputchangehandler = useCallback(debounce(handleSearch), []);

    const handlePageChange = (page) => {
        setfilterpage(page);
    };

    return (
        <>
            <ToolManagmentCard>
                <div className="flex justify-start mb-4">
                    <h4 className="font-lato font-bold text-[18px] text-[#242424]">
                        Employees
                    </h4>
                </div>

                <div className="bg-white rounded-lg border border-gray-100 shadow-sm overflow-hidden">
                    <Table className="w-full text-sm text-gray-700">
                        {/* Modified Header to match Image (Cream background) */}
                        <THead>
                            <Tr className="bg-[#FFF9EE] text-[#4A4A4A] text-sm font-medium border-b border-gray-100">
                                <Th className="py-4 px-6 text-left w-[10%]">S No.</Th>
                                <Th className="py-4 px-6 text-left w-[25%]">Employee Name</Th>
                                <Th className="py-4 px-6 text-left w-[25%]">Mobile Number</Th>
                                <Th className="py-4 px-6 text-left w-[30%]">Email</Th>
                                <Th className="py-4 px-6 text-center w-[10%]">Action</Th>
                            </Tr>
                        </THead>

                        <TBody>
                            {isLoading ? (
                                <Tr>
                                    <Td colSpan={5} className="text-center py-6">
                                        <ThreeDotBouncingLoader />
                                    </Td>
                                </Tr>
                            ) : employeesList.length > 0 ? (
                                employeesList.map((item, index) => (
                                    <Tr
                                        key={item.id}
                                        className="border-t border-gray-100 hover:bg-[#F9FAFB] transition-colors"
                                    >
                                        <Td >
                                            {String((filterpage - 1) * filterlimit + index + 1).padStart(2, "0")}
                                        </Td>
                                        <Td >
                                            {item.name || `${item.first_name || ""} ${item.last_name || ""}` || "-"}
                                        </Td>
                                        <Td>{item.mobile || item.phone || "-"}</Td>
                                        <Td>{item.email || item.user_email || "-"}</Td>
                                        <Td className="py-4 px-6 text-center">
                                            <div className="flex justify-start items-center">
                                                <CommonIconButton
                                                    type="view"
                                                    onClick={() => navigate(`/prospectCompany/view?id=${companyId}&candidate_id=${item.candidate_id}&tab=employees&subtab=view`)}
                                                />

                                            </div>
                                        </Td>
                                    </Tr>
                                ))
                            ) : (
                                <Tr>
                                    <Td colSpan={5} className="text-center text-gray-500 py-6 text-sm">
                                        No matching records found
                                    </Td>
                                </Tr>
                            )}
                        </TBody>
                    </Table>
                </div>

                <div className="flex justify-between items-center mt-3">
                    <Pagination
                        totalCount={totalCount}
                        pageNumber={filterpage}
                        displayPage={employeesList.length}
                        UpdatePageLimit={setfilterlimit}
                        UpdatePage={setfilterpage}
                    />

                    {totalCount > 0 && totalPages > 1 && (
                        <ModernPagination
                            totalPages={totalPages}
                            currentPage={filterpage}
                            onPageChange={handlePageChange}
                        />
                    )}
                </div>

                {/* Modals are kept in code logic for future use, but triggers removed from UI to match image */}
                <AddEditCompanyEmployee
                    dialogOpen={openDialog}
                    onDialogClose={() => setOpenDialog(false)}
                    documentData=""
                    onAdded=""
                />
                <DeleteModal
                    dialogOpen={isOpen}
                    onDialogClose={() => setIsopen(false)}
                    onConfirm={handleDelete}
                    title="Are you sure you want to delete?"
                    subtitle="This action cannot be undone."
                />
            </ToolManagmentCard>
        </>
    );
};

export default CompaniesEmployeesList;